import { LayoutType } from "@apiserver-rest/ponder-data-client-base";

// https://stackoverflow.com/a/41548441/735425
export function enumFromStringValue<T> (enm: { [s: string]: T}, value: string): T | undefined {
    return (Object.values(enm) as unknown as string[]).includes(value)
      ? value as unknown as T
      : undefined;
  }

export function formatCardName(name: string | undefined): string {
    return name?.replace(/\W+/g, '-')?.toLowerCase() ?? "";
}

export function shortenedName(name: string, maxLength: number): string {
    return (name.length > maxLength ? name.substring(0, maxLength) + '…' : name);
}

// lol
export function getNumber(x: number): number {
    return x;
}

export function addDays(date: Date, days: number): Date {
    var d = new Date(date);
    return new Date(d.setDate(d.getDate() + days));
}

export function formatDate(date: Date | undefined, localTime?: boolean): string {
    if (!date) {
        return "N/A";
    }

    // Everything coming from the database is in UTC so default to UTC.
    if (!localTime) {
        var yyyy = "" + date.getUTCFullYear();
        var MM = ("" + (date.getUTCMonth() + 1)).padStart(2, '0');
        var dd = ("" + (date.getUTCDate())).padStart(2, '0');
    
        return `${yyyy}-${MM}-${dd}`;
    } else {
        var yyyy = "" + date.getFullYear();
        var MM = ("" + (date.getMonth() + 1)).padStart(2, '0');
        var dd = ("" + (date.getDate())).padStart(2, '0');

        return `${yyyy}-${MM}-${dd}`;
    }
}

export function formatTime(date: Date | undefined, localTime?: boolean): string {
    if (!date) {
        return "N/A";
    }

    if (!localTime) {
        var hh = ("" + date.getUTCHours()).padStart(2, '0');
        var mm = ("" + date.getUTCMinutes()).padStart(2, '0');
        var ss = ("" + date.getUTCSeconds()).padStart(2, '0');
    
        return `${hh}:${mm}:${ss}`;
    } else {
        var hh = ("" + date.getHours()).padStart(2, '0');
        var mm = ("" + date.getMinutes()).padStart(2, '0');
        var ss = ("" + date.getSeconds()).padStart(2, '0');

        return `${hh}:${mm}:${ss}`;
    }
}

export function formatDatetime(date: Date | undefined, localTime?: boolean): string {
    if (!date) {
        return "N/A";
    }

    var dateStr = formatDate(date, localTime);
    var timeStr = formatTime(date, localTime);
    
    return `${dateStr} ${timeStr}`;
}

export function getBoolean(s: string | undefined | null): boolean {
    if (!s) {
        return false;
    }

    return (s.toLowerCase() === "true") ? true : false;
}

export function canFlip(layout: LayoutType): boolean {
    switch (layout) {
        case LayoutType.Transform:
        case LayoutType.ModalDfc:
        case LayoutType.Meld:
        case LayoutType.DoubleFacedToken:
        case LayoutType.ReversibleCard:
            return true;

        default:
            return false;
    }
}

export function clamp(x: number, min: number, max: number) {
    return (x < min ? min : x > max ? max : x);
}